var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topbar'),_vm._v(" "),_c('div',{staticClass:"container is-fluid"},[_c('div',{staticClass:"breadcrumbs"},[_c('breadcrumbs')],1),_vm._v(" "),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/home.vue?vue&type=template&id=8f17b942&scoped=true
// module id = Pll2
// module chunks = 0